import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useFlag } from '@/lib/api';
import { validatePagedFilterSearch } from '@/lib/filterSearchParams';
import { DocumentSearch } from '@/features/DocumentSearch/DocumentSearch';

function DocumentSearchPage() {
    const { data: isEnabled, isLoading } = useFlag('document_search');
    const navigate = useNavigate();

    if (!isLoading && !isEnabled) {
        navigate({ to: '/' });
        return null;
    }

    return <DocumentSearch />;
}

export const Route = createFileRoute('/meta-search')({
    component: DocumentSearchPage,
    validateSearch: validatePagedFilterSearch,
});
